<div class="loading-indicator" *ngIf="isLoading$ | async">
  <div class="indicator-content">
    <div class="progress-container">
      <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
      <div class="progress-glow"></div>
    </div>
    <div class="message">
      <span class="dot-animation">Loading</span>
    </div>
  </div>
</div>
